import { mapActions, mapGetters } from "vuex";

export const carteMixin = {
  computed: {
    ...mapGetters({
      robCartesIsLoading: "carte/robList/isLoading",
      carteUpdateIsLoading: "carte/update/isLoading",
      robCartes: "carte/robList/items",
      cartes: "carte/list/items",
    }),
  },
  methods: {
    ...mapActions({
      getRobCartes: "carte/robList/getItems",
      getCartes: "carte/list/getItems",
      updateCarte: "carte/update/update",
    }),
  },
};
